const ENROLMENT_META_KEY = Object.freeze({
  ONBOARDING_HUB_WELCOME_NOTIFICATION_DISMISSED: `client-onboarding-hub-welcome-notification-dismissed`,
  ONBOARDING_HUB_REJECTION_NOTIFICATION_DISMISSED: `client-onboarding-hub-rejection-notification-dismissed`,
})

export default ENROLMENT_META_KEY
